import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, BookOpen, ShoppingBag } from "lucide-react";

const socials = [
  { href: "https://www.instagram.com/tobad_imhalo/", label: "instagram", Icon: Instagram },
  { href: "https://www.facebook.com/antoniowinfree", label: "facebook", Icon: Facebook },
  { href: "https://x.com/NamedMany", label: "twitter", Icon: Twitter },
  { href: "https://www.goodreads.com/author/show/68483362.A_R_Winfree", label: "goodreads", Icon: BookOpen },
  { href: "https://www.amazon.com/stores/A.R.-Winfree/author/B0GML3CYK3", label: "amazon", Icon: ShoppingBag },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-800 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <Link to="/" className="font-display text-2xl font-bold text-zinc-50">
            A.R.<span className="text-amber-500"> Winfree</span>
          </Link>
          <p className="mt-4 text-sm text-zinc-500 leading-relaxed max-w-xs">
            Author of supernatural thrillers. Stories where the ordinary world cracks open and something ancient stares back.
          </p>
        </div>

        <div>
          <p className="text-xs tracking-accent uppercase text-amber-500 mb-4">Explore</p>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li><Link to="/books" className="hover:text-zinc-50 transition-colors">Books</Link></li>
            <li><Link to="/about" className="hover:text-zinc-50 transition-colors">About</Link></li>
            <li><Link to="/blog" className="hover:text-zinc-50 transition-colors">Journal</Link></li>
            <li><Link to="/contact" className="hover:text-zinc-50 transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-accent uppercase text-amber-500 mb-4">Follow</p>
          <div className="flex flex-wrap gap-4">
            {socials.map(({ href, label, Icon }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" data-testid={`footer-${label}`} className="h-10 w-10 grid place-items-center border border-zinc-800 text-zinc-400 hover:text-amber-500 hover:border-amber-500 transition-colors">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-zinc-800/60">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 text-xs text-zinc-600 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} A.R. Winfree. All rights reserved.</span>
          <span>Crafted in shadow & ink.</span>
        </div>
      </div>
    </footer>
  );
}
